import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { VALUES } from "@/content/site";
import { Reveal, MaskLine } from "./Reveal";
import { SectionHead } from "./Bits";

export default function About() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section id="nosotros" ref={ref} data-testid="about-section" className="bg-[#ECE8E0] py-24 sm:py-32">
      <div className="container-x grid gap-14 lg:grid-cols-12 lg:gap-16">
        <Reveal className="relative lg:col-span-5">
          <div className="relative aspect-[4/5] overflow-hidden bg-[#1E2228]">
            <motion.img style={{ y }} src="/img/about.webp" alt="Muestras de materiales y acabados sobre una mesa de diseño (imagen ilustrativa)" loading="lazy" decoding="async" className="absolute left-0 top-[-10%] h-[120%] w-full object-cover" />
          </div>
          <div className="absolute -bottom-8 right-4 bg-[#F6F4EF] p-5 shadow-[0_30px_60px_-30px_rgba(30,34,40,0.45)] sm:-right-8 sm:p-7">
            <img src="/brand/logo-full.png" alt="Logotipo de ASSE DECOR Interiorismo" className="h-28 w-auto sm:h-36" loading="lazy" />
          </div>
        </Reveal>
        <div className="lg:col-span-7 lg:pl-6">
          <Reveal><SectionHead index="03" eyebrow="Sobre nosotros" /></Reveal>
          <h2 className="mt-6 font-display text-3xl font-light uppercase leading-[1.08] text-[#1E2228] sm:text-5xl">
            <MaskLine inView>El detalle como</MaskLine>
            <MaskLine inView delay={0.1}><span className="font-serif-it normal-case text-[#8A6C3E]">forma de trabajar</span></MaskLine>
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-8 text-base leading-relaxed text-[#3A414B] sm:text-lg">
              ASSE DECOR INTERIORISMO SL es una empresa de interiorismo y reformas con sede en San Sebastián de los Reyes (Madrid). Entendemos cada proyecto como un encargo personal: escuchar, proponer con criterio y ejecutar con cuidado, para que el resultado se parezca a quien lo va a vivir.
            </p>
            <p className="mt-5 text-base leading-relaxed text-[#3A414B]">
              Trabajamos tanto en viviendas como en locales y espacios de trabajo, acompañando al cliente desde la primera conversación hasta la entrega.
            </p>
          </Reveal>
          <div className="mt-12 grid gap-px bg-[#1E2228]/10 sm:grid-cols-2">
            {VALUES.map((v, i) => (
              <Reveal key={v.title} delay={i * 0.08} className="bg-[#ECE8E0] py-6 sm:p-6">
                <h3 className="font-display text-sm font-semibold uppercase tracking-[0.14em] text-[#1E2228]">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#3A414B]">{v.desc}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
